import React from 'react';


export function JsonRenderer({data}) {
    // 1) Примитивы
    if (typeof data === 'string' || typeof data === 'number' || typeof data === 'boolean') {
        return (
            <span
                dangerouslySetInnerHTML={
                    typeof data === 'string' ? {__html: data} : undefined
                }
            >
        {typeof data !== 'string' ? String(data) : null}
      </span>
        );
    }
    // 2) Массив → ul > li
    if (Array.isArray(data)) {
        return (
            <ul style={{paddingLeft: 0}}>
                {data.map((item, i) => (
                    <li key={i}>
                        <JsonRenderer data={item}/>
                    </li>
                ))}
            </ul>
        );
    }

    // 3) Объект
    if (typeof data === 'object' && data !== null) {
        const {img, text, title, description, link, ...rest} = data;

        // 3.1) Картинка + текст
        if (img != null && typeof text === 'string') {
            return (
                <div>
                    <img src={img} alt=""/>
                    <span style={{marginLeft: 10}} dangerouslySetInnerHTML={{__html: text}}/>
                </div>
            );
        }

        // 3.2) Заголовок + описание
        if (Array.isArray(description)) {
            return (
                <div>
                    {typeof title === 'string' && <h5 dangerouslySetInnerHTML={{__html: title}}/>}
                    <ul style={{marginBottom: 32}}>
                        {description.map((line, i) =>
                            line.length === 0 ? (
                                <br key={i}/>
                            ) : (
                                <li key={i}>
                                    <JsonRenderer data={line}/>
                                </li>
                            )
                        )}
                    </ul>
                    {link && (
                        <p>
                            <a href={link} target="_blank" rel="noopener noreferrer">
                                Подробнее
                            </a>
                        </p>
                    )}
                </div>
            );
        }

        // 3.3) Любой другой объект → ключ: значение
        return (
            <div>
                {Object.entries(rest).map(([key, value]) => (
                    <div key={key}>
                        <strong>{key}:</strong> <JsonRenderer data={value}/>
                    </div>
                ))}
            </div>
        );
    }

    return null;
}
